import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import * as actions from '../../store/actions/index';
import Message from './Message.js';
import PropTypes from 'prop-types';
var moment = require('moment');
var internalTimer;

const styles = theme => ({
    inputForm: {
        marginBottom: '5px',
        marginRight: '10px',
        display: 'flex',
        gap: '5px',
        [theme.breakpoints.down('sm')]: {
            marginRight: '5px',
            gap: '3px'
        }
    },
    textInput: {
        flex: 1,
        padding: '8px',
        fontSize: '14px',
        borderRadius: '5px',
        border: '1px solid #ccc',
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px',
            padding: '6px'
        }
    },
    submitButton: {
        background: '#a52423',
        color: 'white',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            padding: '6px 12px',
            fontSize: '12px'
        }
    }
});

class Chatroom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uniqueId: localStorage.getItem('token'),
            username: this.props.clientName,
            userSent: true,
            typeOfAccount: localStorage.getItem('typeOfAccount')
        };
        this.submitMessage = this.submitMessage.bind(this);
        this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'));
    }

    componentDidMount() {
        //this.props.getCaseInfo(this.props.caseId);
        this.props.getAllChatMsg(this.props.caseId);
        if (this.state.uniqueId == this.props.claimantUniqueId){
            this.setState({
                username: this.props.claimant_name
            });
        }
        else if (this.state.uniqueId == this.props.respondentUniqueId){
            this.setState({
                username: this.props.respondent_name
            });
        }
        else if (this.state.typeOfAccount == 'admin'){
            this.setState({
                username: 'Admin'
            });
        }
        else if (this.state.typeOfAccount == 'arbitrator'){
            this.setState({
                username: 'Arbitrator'
            });
        }

        internalTimer = setInterval(()=>{

            this.props.getAllChatMsg(this.props.caseId);
            if (this.state.uniqueId == this.props.claimantUniqueId){
                this.setState({
                    username: this.props.claimant_name
                });
            }
            else if (this.state.uniqueId == this.props.respondentUniqueId){
                this.setState({
                    username: this.props.respondent_name
                });
            }
            else if (this.state.typeOfAccount == 'admin'){
                this.setState({
                    username: 'Admin'
                });
            }
            else if (this.state.typeOfAccount == 'arbitrator'){
                this.setState({
                    username: 'Arbitrator'
                });
            }

        },2000)

        this.scrollToBot();
          
    }

    componentWillUnmount(){
        if (internalTimer !== undefined)
        clearInterval(internalTimer)
    }

    componentDidUpdate() {
        // console.log('componentDidUpdate: userSent: '+this.state.userSent)
        if (this.state.userSent){
            this.scrollToBot();
            this.scrollToBot();
            this.scrollToBot();

            console.log('componentDidUpdate: scrollToBot ')
            setTimeout(()=>{
                this.setState({
                    userSent:false
                })
            },2500)
        }
    }

    scrollToBot() {
        ReactDOM.findDOMNode(this.refs.chats).scrollTop = ReactDOM.findDOMNode(this.refs.chats).scrollHeight;
    }

    submitMessage(e) {
        e.preventDefault();
        
        //localStorage.getItem('token'),
        if (this.state.uniqueId == this.props.claimantUniqueId){
            this.setState({
                username: this.props.claimant_name
            });
        }
        else if (this.state.uniqueId == this.props.respondentUniqueId){
            this.setState({
                username: this.props.respondent_name
            });
        }
        else if (this.state.typeOfAccount == 'admin'){
            this.setState({
                username: 'Admin'
            });
        }
        else if (this.state.typeOfAccount == 'arbitrator'){
            this.setState({
                username: 'Arbitrator'
            });
        }

        setTimeout(() => {
            console.log('Chatroon this.props.userType: '+this.props.userType);
            console.log('Chatroon this.props.clientName: '+this.props.clientName);
            console.log('Chatroon this.state.username: '+this.state.username);

            console.log('Chatroon this.props.claimant_name: '+this.props.claimant_name);
            console.log('Chatroon this.props.respondent_name: '+this.props.respondent_name);

            console.log('Chatroon this.props.claimantUniqueId: '+this.props.claimantUniqueId);
            console.log('Chatroon this.props.respondentUniqueId: '+this.props.respondentUniqueId);
            console.log('Chatroon this.state.uniqueId: '+this.state.uniqueId);
            if ((this.refs.msg).value !== ''){
                var timestamp = moment().format('MMM Do YYYY, h:mm a');

                let uniqueId = localStorage.getItem('token');
            let userType = '';
                if(this.props.claimantUniqueId == uniqueId){
                    userType = 'claimant';
                }else if(this.props.respondentUniqueId == uniqueId){
                    userType = 'respondent';
                }
                else if (localStorage.getItem('typeOfAccount') == 'admin'){
                    userType = 'admin'
                }
                else if (localStorage.getItem('typeOfAccount') == 'arbitrator'){
                    userType = 'arbitrator'
                }
    
                this.props.saveChatMsg({
                                        caseId:this.props.caseId,
                                        username:this.state.username,
                                        content:(this.refs.msg).value,
                                        timestamp:timestamp,
                                        userType:userType
                                      });
    
                this.setState({
                    // userSent:true
                }, () => {
                    ReactDOM.findDOMNode(this.refs.msg).value = "";
                });
    
                this.setState({
                    userSent:true
                })
                this.scrollToBot();
    
            }
        }, 1000);
        
    }

    render() {
        const { classes } = this.props;
        
        return (
            <div className="chatroom">
               
                <ul className="chats" ref="chats">
                    { this.props.chats.map( (chat) => <Message chat={chat} user={this.state.username} /> ) }
                </ul>
                {
                    this.state.username !== 'Admin' && 
                    <form className={classes.inputForm} onSubmit={(e) => this.submitMessage(e)}>
                        <input type="text" ref="msg" className={classes.textInput} />
                        <input type="submit" value={this.context.t('Send')} className={classes.submitButton} />
                    </form>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    let uniqueId = localStorage.getItem('token');
    let userType = '';
        if(state.caseInfo.caseData.claimantUniqueId == uniqueId){
            userType = 'claimant';
        }else if(state.caseInfo.caseData.respondentUniqueId == uniqueId){
            userType = 'respondent';
        }
        else if (localStorage.getItem('typeOfAccount') == 'admin'){
            userType = 'admin'
        }
        else if (localStorage.getItem('typeOfAccount') == 'arbitrator'){
            userType = 'arbitrator'
        }

    if (state.caseInfo.caseData.agreement_type == 'EstateAgentDispute'){

        if (state.caseInfo.caseData.a2  == 'purchaser' || state.caseInfo.caseData.a2  == 'vendor'){
            if (userType == 'claimant'){
                    
                return {
                    caseId: state.caseInfo.caseId,
                    claimantUniqueId: state.caseInfo.claimantUniqueId,
                    respondentUniqueId: state.caseInfo.respondentUniqueId,
                    caseData: state.caseInfo.caseData,
                    claimant_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                    respondent_name: state.caseInfo.caseData.a12,
                    userType: state.caseInfo.userType,
                    clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                    chats: state.chatroom.payload,
                    addChatError: state.chatroom.addChatEnquirySettlementError,
                    getChatError: state.chatroom.getChatEnquirySettlementError,
                }
                
            }
            else if (userType == 'respondent'){
    
                return {
                    caseId: state.caseInfo.caseId,
                    claimantUniqueId: state.caseInfo.claimantUniqueId,
                    respondentUniqueId: state.caseInfo.respondentUniqueId,
                    caseData: state.caseInfo.caseData,
                    claimant_name: state.caseInfo.caseData.namesOfPurchasers[0].a4,
                    respondent_name: state.caseInfo.caseData.a12,
                    userType: state.caseInfo.userType,
                    clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                    chats: state.chatroom.payload,
                    addChatError: state.chatroom.addChatEnquirySettlementError,
                    getChatError: state.chatroom.getChatEnquirySettlementError,
                }
                
            }
            else if (userType == 'admin'){
             
                return {
                    caseId: state.caseInfo.caseId,
                    claimantUniqueId: state.caseInfo.claimantUniqueId,
                    respondentUniqueId: state.caseInfo.respondentUniqueId,
                    caseData: state.caseInfo.caseData,
                    claimant_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                    respondent_name: state.caseInfo.caseData.a12,
                    userType: state.caseInfo.userType,
                    clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                    chats: state.chatroom.payload,
                    addChatError: state.chatroom.addChatEnquirySettlementError,
                    getChatError: state.chatroom.getChatEnquirySettlementError,
                }
                
            }
            else if (userType == 'arbitrator'){
    
                return {
                    caseId: state.caseInfo.caseId,
                    claimantUniqueId: state.caseInfo.claimantUniqueId,
                    respondentUniqueId: state.caseInfo.respondentUniqueId,
                    caseData: state.caseInfo.caseData,
                    claimant_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                    respondent_name: state.caseInfo.caseData.a12,
                    userType: state.caseInfo.userType,
                    clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                    chats: state.chatroom.payload,
                    addChatError: state.chatroom.addChatEnquirySettlementError,
                    getChatError: state.chatroom.getChatEnquirySettlementError,
                }
            }
        }
        else{
            if (userType == 'claimant'){
                if (state.caseInfo.caseData.a3 !== undefined){
                    
                    if (state.caseInfo.caseData.a1 == 'sole'){
                    
                        if (state.caseInfo.caseData.a2 == 'vendor'){
                            return {
                                caseId: state.caseInfo.caseId,
                                claimantUniqueId: state.caseInfo.claimantUniqueId,
                                respondentUniqueId: state.caseInfo.respondentUniqueId,
                                caseData: state.caseInfo.caseData,
                                claimant_name: state.caseInfo.caseData.a3,
                                respondent_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                                userType: state.caseInfo.userType,
                                clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                                chats: state.chatroom.payload,
                                addChatError: state.chatroom.addChatEnquirySettlementError,
                                getChatError: state.chatroom.getChatEnquirySettlementError,
                            }
                        }
                        else if (state.caseInfo.caseData.a2 == 'purchaser'){
                            return {
                                caseId: state.caseInfo.caseId,
                                claimantUniqueId: state.caseInfo.claimantUniqueId,
                                respondentUniqueId: state.caseInfo.respondentUniqueId,
                                caseData: state.caseInfo.caseData,
                                claimant_name: state.caseInfo.caseData.a3,
                                respondent_name: state.caseInfo.caseData.namesOfPurchasers[0].a12a,
                                userType: state.caseInfo.userType,
                                clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                                chats: state.chatroom.payload,
                                addChatError: state.chatroom.addChatEnquirySettlementError,
                                getChatError: state.chatroom.getChatEnquirySettlementError,
                            }
                        }
        
                    }
                    else if (state.caseInfo.caseData.a1 == 'seperate'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfA2[0].a4,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroom.payload,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }

                }
            }
            else if (userType == 'respondent'){

                if (state.caseInfo.caseData.a1 == 'sole'){
                    
                    if (state.caseInfo.caseData.a2 == 'vendor'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroom.payload,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }
                    else if (state.caseInfo.caseData.a2 == 'purchaser'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfPurchasers[0].a12a,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroom.payload,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }

                }
                else if (state.caseInfo.caseData.a1 == 'seperate'){
                    return {
                        caseId: state.caseInfo.caseId,
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        caseData: state.caseInfo.caseData,
                        claimant_name: state.caseInfo.caseData.a3,
                        respondent_name: state.caseInfo.caseData.namesOfA2[0].a4,
                        userType: state.caseInfo.userType,
                        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                        chats: state.chatroom.payload,
                        addChatError: state.chatroom.addChatEnquirySettlementError,
                        getChatError: state.chatroom.getChatEnquirySettlementError,
                    }
                }
                
            }
            else if (userType == 'admin'){
                if (state.caseInfo.caseData.a1 == 'sole'){
                    
                    if (state.caseInfo.caseData.a2 == 'vendor'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroom.payload,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }
                    else if (state.caseInfo.caseData.a2 == 'purchaser'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfPurchasers[0].a12a,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroom.payload,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }

                }
                else if (state.caseInfo.caseData.a1 == 'seperate'){
                    return {
                        caseId: state.caseInfo.caseId,
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        caseData: state.caseInfo.caseData,
                        claimant_name: state.caseInfo.caseData.a3,
                        respondent_name: state.caseInfo.caseData.namesOfA2[0].a4,
                        userType: state.caseInfo.userType,
                        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                        chats: state.chatroom.payload,
                        addChatError: state.chatroom.addChatEnquirySettlementError,
                        getChatError: state.chatroom.getChatEnquirySettlementError,
                    }
                }
            }
            else if (userType == 'arbitrator'){

                if (state.caseInfo.caseData.a1 == 'sole'){
                    
                    if (state.caseInfo.caseData.a2 == 'vendor'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroom.payload,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }
                    else if (state.caseInfo.caseData.a2 == 'purchaser'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfPurchasers[0].a12a,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroom.payload,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }

                }
                else if (state.caseInfo.caseData.a1 == 'seperate'){
                    return {
                        caseId: state.caseInfo.caseId,
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        caseData: state.caseInfo.caseData,
                        claimant_name: state.caseInfo.caseData.a3,
                        respondent_name: state.caseInfo.caseData.namesOfA2[0].a4,
                        userType: state.caseInfo.userType,
                        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                        chats: state.chatroom.payload,
                        addChatError: state.chatroom.addChatEnquirySettlementError,
                        getChatError: state.chatroom.getChatEnquirySettlementError,
                    }
                }

            }
        }
        
    }
    else if (state.caseInfo.caseData.agreement_type == 'MoneyLent'){
        return {
            caseId: state.caseInfo.caseId,
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            caseData: state.caseInfo.caseData,
            claimant_name: state.caseInfo.claimant_name,
            respondent_name: state.caseInfo.respondent_name,
            userType: state.caseInfo.userType,
            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
            chats: state.chatroom.payload,
            addChatError: state.chatroom.addChatEnquirySettlementError,
            getChatError: state.chatroom.getChatEnquirySettlementError,
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'other_dispute'){
        return {
            caseId: state.caseInfo.caseId,
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            caseData: state.caseInfo.caseData,
            claimant_name: state.caseInfo.caseData.a1,
            respondent_name: state.caseInfo.caseData.a9,
            userType: state.caseInfo.userType,
            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
            chats: state.chatroom.payload,
            addChatError: state.chatroom.addChatEnquirySettlementError,
            getChatError: state.chatroom.getChatEnquirySettlementError,
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'SalesOfGoods' || state.caseInfo.caseData.agreement_type == 'serviceDispute' || 
    state.caseInfo.caseData.agreement_type == 'insuranceDispute'){
        
        return {
            caseId: state.caseInfo.caseId,
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            caseData: state.caseInfo.caseData,
            claimant_name: state.caseInfo.caseData.a1,
            respondent_name: state.caseInfo.caseData.a9,
            userType: state.caseInfo.userType,
            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
            chats: state.chatroom.payload,
            addChatError: state.chatroom.addChatEnquirySettlementError,
            getChatError: state.chatroom.getChatEnquirySettlementError,
        }
        
    }

}

const mapDispatchToProps = (dispatch) => {
    return {
           //getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
           saveChatMsg: (payload) => dispatch(actions.saveChatMsg(payload)),
           getAllChatMsg: (caseId) => dispatch(actions.getAllChatMsg(caseId)),
           getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
    }
}


Chatroom.contextTypes = {
    t: PropTypes.func
  }

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Chatroom));